import darken from "darken";

function createDarkToggleHandler(element) {
    const toggleClasses = ["forwards", "reverse"];

    return function () {
        const [addClass, removeClass] = element.classList.contains(
            toggleClasses[0]
        )
            ? toggleClasses.reverse()
            : toggleClasses;

        element.classList.add(addClass);
        element.classList.remove(removeClass);
    };
}


export default {
    init: function () {
        document
            .querySelector("#switch")
            .addEventListener(
                "click",
                createDarkToggleHandler(document.querySelector("#circle"))
            );

        const variables = JSON.parse(
            document.querySelector("main").dataset.darkenVariables
        );

        new darken({
            toggle: "#switch",
            remember: "darken-mode",
            class: "darken",
            variables,
            usePrefersColorScheme: true
        });
    }
};
